import type { BasketFilters } from '@/features/baskets/api/basketsService'

/**
 * Query key factory. A list keys on its audience and tag. A basket keys on its slug, which is also its route key; the one-company
 * check keys on the symbol too.
 */
export const basketsKeys = {
  all: ['baskets'] as const,
  list: ({ audience, tag }: BasketFilters) =>
    [...basketsKeys.all, 'list', audience, tag ?? ''] as const,
  detail: (slug: string) => [...basketsKeys.all, 'detail', slug] as const,
  inOut: (slug: string) => [...basketsKeys.all, 'in-out', slug] as const,
  history: (slug: string) => [...basketsKeys.all, 'history', slug] as const,
  backtest: (slug: string) => [...basketsKeys.all, 'backtest', slug] as const,
  check: (slug: string, symbol: string) => [...basketsKeys.all, 'check', slug, symbol] as const,
}
